<template>
  <div>
    <div v-if="$route.path.indexOf('_setting') === -1">
      <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onReset">
        <SpFilterFormItem prop="aftersalesType" label="">
          <el-select v-model="formData.aftersalesType" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </SpFilterFormItem>
        <SpFilterFormItem prop="status" label="">
          <el-button type="primary" @click="addCategory">添加售后原因</el-button>
        </SpFilterFormItem>
      </SpFilterForm>
      <SpFinder no-selection ref="finder" :setting="setting" row-actions-width="250" :row-actions-align="'left'"
        :fixed-row-action="true" :url="url" :hooks="{
          beforeSearch: beforeSearch,
          afterSearch: afterSearch
        }" :split-count="5">
      </SpFinder>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { createSetting } from '@shopex/finder'
import { useDialog } from '@shopex/finder'
import { afterSaleList, aftersalesSettingReasonDetail, deleteAftersalesSettingReason  } from './api'

const commonActions = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '保存', key: 'save', type: 'primary', size: 'default' }
]

export default {
  components: {
  },
  data() {
    return {
      url: afterSaleList,
      formData: {
        aftersalesType: '',
      },
      options: [{
        value: '2',
        label: '部分退款'
      },
      {
        value: '1',
        label: '退货退款'
      }
      ],
      setting: createSetting({
        columns: [
          { name: '售后原因', key: 'reason_name' },
          {
            name: '所属类型', key: 'aftersales_type',
            render: (h, { row }) => {
              let { aftersales_type } = row
              // aftersales_type是个字符串，用逗号分隔，1代表退货退款，2代表部分退款，1和2都存在则代表两者都存在，我需要显示文字输出
              if (aftersales_type) {
                // aftersales_type = aftersales_type.split(',')
                if (aftersales_type.includes('1') && aftersales_type.includes('2')) {
                  return <span type="warning" effect="light">部分退款、退货退款</span>
                } else if (aftersales_type.includes('1')) {
                  return <span type="warning" effect="light">退货退款</span>
                } else if (aftersales_type.includes('2')) {
                  return <span type="warning" effect="light">部分退款</span>
                }
              }
            }
          },
          {
            name: '上传图片', key: 'need_upload_images',
            render: (h, { row }) => {
              let { need_upload_images } = row
              // 0不需要，1展示，2展示并必填,文字输出
              if (need_upload_images) {
                if (need_upload_images === '1') {
                  return <span>展示</span>
                } else if (need_upload_images === '2') {
                  return <span>展示、必填</span>
                }
              }
            }
          },
          {
            name: '填写说明', key: 'need_fill_describe',
            render: (h, { row }) => {
              let { need_fill_describe } = row
              // 0不需要，1展示，2展示并必填,文字输出
              if (need_fill_describe) {
                if (need_fill_describe === '1') {
                  return <span>展示</span>
                } else if (need_fill_describe === '2') {
                  return <span>展示、必填</span>
                }
              }
            }
          },
        ],
        actions: [
          {
            name: '编辑',
            key: 'edit',
            type: 'button',
            buttonType: 'text',
            action: {
              handler: async (row) => {
                this.addCategory(row[0])
              }
            }
          },
          {
            name: '删除',
            key: 'delete',
            type: 'button',
            buttonType: 'text',
            action: {
              handler: (row) => {
                this.handleDeleteDialog(row[0])
              }
            }
          },
        ]
      }),
    }
  },
  methods: {
    // 添加分类
    async addCategory(item) {
      let info = {}
      if (item.id) {
        const data = await aftersalesSettingReasonDetail({ id: item.id })
        info = data.data.data
      }
      useDialog(null, {
        title: item.id ? '编辑售后原因' : `添加售后原因`,
        width: '50%',
        info: info,
        component: () => import('./comps/add.vue'),
        actions: commonActions
      }).then((data) => {
        if (data) this.$refs.finder.refresh()
      })
    },
    beforeSearch(params) {
      const { aftersalesType } = this.formData
      const pamars = {
        ...params,
        page_size: params.pageSize,
        aftersales_type: aftersalesType
      }
      return pamars
    },
    afterSearch(res) {
      const { data } = res.data
      return data
    },
    handleDeleteDialog(row) {
      deleteAftersalesSettingReason({ id: row.id }).then(res => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.$nextTick(() => {
          this.$refs.finder.refresh()
        })
      })
    },
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    onReset() {
      this.formData = {
        aftersalesType: ''
      }
      this.$refs.finder.refresh(true)
    },
  }
}
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.sp-finder-hd {
  padding-top: 10px !important;
}

.view-template-dialog {
  .sp-finder-hd {
    display: none;
  }

  .el-dialog__body {
    padding: 0 !important;

    .el-form {
      margin: 0 !important;
    }

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}
</style>
